import { useNavigate } from "react-router-dom";
import { relativeURL } from "../relativeURL";

export const useStarterPathway = () => {
  let navigate = useNavigate();
  async function startPathway(species, database, nativeId) {
    // TODO: handle errors
    const resp = await fetch(relativeURL("/api/starter"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        species: species,
        database: database,
        nativeId: nativeId,
      }),
    });

    const body = await resp.json();
    navigate(`/session/${body.sid}`);
  }

  return {
    startPathway,
  };
};
